import { useMutation } from '@tanstack/react-query';
import { TEN_SECONDS, TOAST_ERROR, showToast } from 'lib/utils';

import { makeRemoteGenerateAccruals } from 'main/factories/usecases';

export const useJournalEntriesGenerateAccruals = (locationId: string, externalId: number) => {
  return useMutation({
    mutationFn: (data: any) => {
      const service = makeRemoteGenerateAccruals();
      return service.createAccruals({ locationId, externalId });
    },
    onError: () => {
      showToast('Error while generating accruals', TOAST_ERROR, TEN_SECONDS);
    },
  });
};
